// @flow
import reducer from "./reducers";

import * as workspacesOperations from "./operations";
import * as workspacesSelectors from "./selectors";

export { workspacesOperations, workspacesSelectors };

export default reducer;
